import React, { useState } from 'react';
import VendasPanel from '../components/marketing/VendasPanel';
import { Alert, Container, Spinner, Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../UserContext';
import { useEntidadeContext } from '../EntidadeContext';
import ClientesPanel from '../components/marketing/ClientesPanel';

export default function ComercialPage() {
    const navigate = useNavigate();
    const [saleId, setSaleId] = useState(null);
    const [selectedTab, setSelectedTab] = useState('comercial_clientes');
    const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig } = useUserContext();
    const { currentEntidade } = useEntidadeContext();
    const canOpenCrm = currentEntidade?.modulos_ativos?.includes('crm')
        && getPermittedInternalTabs('crm', currentUserRole).length > 0;
    const tabs = getPermittedInternalTabs('comercial', currentUserRole);
    if (isLoadingAccessConfig) return <Spinner animation="border" role="status" />;
    const activeTab = tabs.some(t => t.key === selectedTab) ? selectedTab : tabs[0]?.key;
    if (!tabs.length) {
        return <Alert variant="warning">Seu perfil não possui acesso ao Comercial.</Alert>;
    }
    return <Container fluid className="commercial-page">
        <div className="commercial-breadcrumb">Gestão <span>/</span> <strong>Comercial</strong></div>
        <Nav variant="tabs" className="mb-4" activeKey={activeTab} onSelect={setSelectedTab}>{tabs.map(tab => <Nav.Item key={tab.key}><Nav.Link eventKey={tab.key}>{tab.title || (tab.key === 'comercial_clientes' ? 'Clientes' : 'Vendas e recebimentos')}</Nav.Link></Nav.Item>)}</Nav>
        {activeTab === 'comercial_vendas' && <VendasPanel key={currentEntidade?.id} initialSaleId={saleId} onInitialSaleOpened={() => setSaleId(null)} />}
        {activeTab === 'comercial_clientes' && <ClientesPanel onOpenSale={tabs.some(t => t.key === 'comercial_vendas') ? id => { setSaleId(id); setSelectedTab('comercial_vendas'); } : undefined} key={currentEntidade?.id} onOpenLead={canOpenCrm ? id => navigate(`/crm?lead=${id}`) : undefined} />}
    </Container>;
}
